export const LOBBY_ROUTE = "/";
export const GAME_ROUTE = "/game";
export const TOURNAMENTS_ARENA_ROUTE = "/tournaments-arena";
